import jobServices from 'ApiService/Placement/jobServices';
import Card from 'components/card';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AllStudents from './Steps/AllStudents';
import { AuthContext } from 'contexts/AuthContext';

const Index = () => {
  const [studentDetails, setStudentDetails] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [classData, setClassData] = useState({
    courseId: '',
    batchId: '',
  });
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const { state } = useContext(AuthContext);

  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Assign Job' },
  ];

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const selectedBranch = state?.selectedBranch || '';
      const response = await jobServices.getCourseBatch(selectedBranch);

      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className=" w-md:2/3 mx-auto h-full  w-full md:px-3 3xl:w-7/12">
        <Card
          extra={
            ' -mt-[280px]  w-full md:-mt-[340px] md:px-[30px] h-full mx-auto pb-3'
          }
        >
          <div className="w-full rounded-[20px]">
            <UseContextProvider>
              <AllStudents
                studentDetails={studentDetails}
                setLoading={setLoading}
                setDisable={setDisable}
                classData={classData}
                setClassData={setClassData}
                // handleCheckboxChange={handleCheckboxChange}

                courses={courses}
                loadingCourses={loadingCourses}
                setStudentDetails={setStudentDetails}
              />
            </UseContextProvider>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
